import React, { createContext, useContext, useState } from 'react';

const translations = {
  en: {
    // Navigation
    nav: {
      services: 'Services',
      about: 'About',
      testimonials: 'Testimonials',
      location: 'Location',
      contact: 'Contact',
      bookNow: 'Book Now'
    },
    // Hero
    hero: {
      headline: 'Experience True Healing & Restorative Care',
      subheadline: 'Expert Acupuncture and Oriental Medicine in Garden Grove. We treat the root cause of your pain to restore your life.',
      cta: 'Book an Appointment',
      phone: '(714) 591-5360'
    },
    // About Dr. Choi
    about: {
      caption: 'The Dr. Choi Difference',
      title: 'Master of Acupuncture & True Healer',
      description: 'Dr. Choi brings decades of expertise in traditional oriental medicine, combining time-tested techniques with modern understanding. She is extremely knowledgeable and takes the time to explain the healing process clearly to every patient.',
      feature1Title: 'Expert for All Ages',
      feature1Desc: 'Successfully treating younger generations seeking natural wellness solutions, as well as elderly patients with long-term injuries.',
      feature2Title: 'Holistic Approach',
      feature2Desc: 'Every treatment plan is personalized to address the root cause, not just the symptoms.',
      feature3Title: 'Modern & Traditional',
      feature3Desc: 'A perfect blend of ancient wisdom and contemporary healing techniques.'
    },
    // Services
    services: {
      caption: 'Our Specialties',
      title: 'Comprehensive Healing Services',
      chronicPain: 'Chronic Pain Relief',
      chronicPainDesc: 'Neck, back, and joint pain treatment using targeted acupuncture and holistic approaches.',
      sinus: 'Sinus & Sinusitis',
      sinusDesc: 'Natural relief for sinus congestion, allergies, and chronic sinusitis conditions.',
      sleep: 'Sleep Improvement',
      sleepDesc: 'Address insomnia and frequent urination issues for restful, rejuvenating sleep.',
      perimenopause: 'Perimenopausal Care',
      perimenopauseDesc: 'Gentle, effective treatment for hormonal balance and symptom relief.',
      energy: 'Energy Recovery',
      energyDesc: 'Combat fatigue and restore vitality through traditional healing methods.'
    },
    // Techniques
    techniques: {
      caption: 'Treatment Methods',
      title: 'Traditional & Modern Techniques',
      acupuncture: 'Traditional Acupuncture',
      acupunctureDesc: 'Precise needle placement to restore energy flow and promote natural healing.',
      electric: 'Electric Acupuncture',
      electricDesc: 'Enhanced stimulation for deeper therapeutic effects and faster recovery.',
      cupping: 'Cupping Therapy',
      cuppingDesc: 'Both dry and wet cupping available for muscle tension and circulation.',
      herbal: 'Herbal Remedies',
      herbalDesc: 'Customized herbal prescriptions to support your healing journey.',
      stickers: 'Acupuncture Stickers',
      stickersDesc: 'Take-home care solutions for continued healing between visits.'
    },
    // Testimonials
    testimonials: {
      caption: 'Patient Stories',
      title: 'What Our Patients Say',
      rating: '5.0 Star Rating',
      reviews: '11 Reviews',
      quote1: 'Improved breathing and sleep. A blend of modern and traditional approach.',
      quote2: 'After two appointments, Dr. Choi changed my life! Relieved my 8-year lower back pain.',
      quote3: 'Amazing results for sinus issues and general fatigue. A treasure in Orange County.'
    },
    // Accessibility
    accessibility: {
      caption: 'Accessibility',
      title: 'We Welcome Everyone',
      statement: 'Our clinic is fully accessible and compliant with ADA standards. We are committed to providing care for all patients.',
      wheelchair: 'Wheelchair Accessible Entrance',
      parking: 'Accessible Parking Lot',
      restroom: 'Accessible Restroom'
    },
    // Location
    location: {
      caption: 'Visit Us',
      title: 'Find Our Clinic',
      address: '9860 Garden Grove Blvd',
      city: 'Garden Grove, CA 92844',
      plaza: 'Hanmi Plaza',
      planning: 'Appointments Recommended',
      insurance: 'Excellent Insurance Coverage',
      payment: 'Credit Cards & Debit Cards Accepted',
      hours: 'Business Hours',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
      closed: 'Closed'
    },
    // Footer
    footer: {
      clinic: 'Healing Clinic',
      clinicKorean: '힐링한의원',
      tagline: 'Traditional Oriental Medicine • Modern Healing',
      accessibilityStatement: 'Accessibility Statement',
      accessibilityText: 'This website is designed to be accessible to all users following WCAG 2.1 Level AA guidelines.',
      copyright: '© 2024 Healing Clinic. All rights reserved.',
      seo: 'Acupuncture Garden Grove | Acupuncture Orange County'
    }
  },
  vi: {
    // Navigation
    nav: {
      services: 'Dịch Vụ',
      about: 'Giới Thiệu',
      testimonials: 'Đánh Giá',
      location: 'Địa Điểm',
      contact: 'Liên Hệ',
      bookNow: 'Đặt Lịch'
    },
    // Hero
    hero: {
      headline: 'Trải Nghiệm Chữa Lành Thực Sự & Chăm Sóc Phục Hồi',
      subheadline: 'Châm cứu và Y học Đông phương chuyên nghiệp tại Garden Grove. Chúng tôi điều trị nguyên nhân gốc rễ của cơn đau để phục hồi cuộc sống của bạn.',
      cta: 'Đặt Lịch Hẹn',
      phone: '(714) 591-5360'
    },
    // About Dr. Choi
    about: {
      caption: 'Sự Khác Biệt của Bác Sĩ Choi',
      title: 'Bậc Thầy Châm Cứu & Người Chữa Bệnh Thực Thụ',
      description: 'Bác sĩ Choi mang đến nhiều thập kỷ kinh nghiệm trong y học Đông phương truyền thống, kết hợp các kỹ thuật đã được kiểm chứng với hiểu biết hiện đại. Bà cực kỳ am hiểu và dành thời gian giải thích rõ ràng quy trình chữa bệnh cho mỗi bệnh nhân.',
      feature1Title: 'Chuyên Gia Cho Mọi Lứa Tuổi',
      feature1Desc: 'Điều trị thành công cho thế hệ trẻ tìm kiếm giải pháp sức khỏe tự nhiên, cũng như bệnh nhân cao tuổi với chấn thương lâu năm.',
      feature2Title: 'Phương Pháp Toàn Diện',
      feature2Desc: 'Mỗi kế hoạch điều trị được cá nhân hóa để giải quyết nguyên nhân gốc rễ, không chỉ triệu chứng.',
      feature3Title: 'Hiện Đại & Truyền Thống',
      feature3Desc: 'Sự kết hợp hoàn hảo giữa trí tuệ cổ xưa và kỹ thuật chữa bệnh đương đại.'
    },
    // Services
    services: {
      caption: 'Chuyên Khoa',
      title: 'Dịch Vụ Chữa Bệnh Toàn Diện',
      chronicPain: 'Giảm Đau Mãn Tính',
      chronicPainDesc: 'Điều trị đau cổ, lưng và khớp bằng châm cứu mục tiêu và phương pháp toàn diện.',
      sinus: 'Xoang & Viêm Xoang',
      sinusDesc: 'Giảm đau tự nhiên cho nghẹt xoang, dị ứng và các tình trạng viêm xoang mãn tính.',
      sleep: 'Cải Thiện Giấc Ngủ',
      sleepDesc: 'Giải quyết mất ngủ và tiểu đêm thường xuyên để có giấc ngủ phục hồi.',
      perimenopause: 'Chăm Sóc Tiền Mãn Kinh',
      perimenopauseDesc: 'Điều trị nhẹ nhàng, hiệu quả để cân bằng hormone và giảm triệu chứng.',
      energy: 'Phục Hồi Năng Lượng',
      energyDesc: 'Chống mệt mỏi và phục hồi sức sống thông qua các phương pháp chữa bệnh truyền thống.'
    },
    // Techniques
    techniques: {
      caption: 'Phương Pháp Điều Trị',
      title: 'Kỹ Thuật Truyền Thống & Hiện Đại',
      acupuncture: 'Châm Cứu Truyền Thống',
      acupunctureDesc: 'Đặt kim chính xác để khôi phục dòng năng lượng và thúc đẩy chữa lành tự nhiên.',
      electric: 'Châm Cứu Điện',
      electricDesc: 'Kích thích tăng cường để có hiệu quả trị liệu sâu hơn và phục hồi nhanh hơn.',
      cupping: 'Giác Hơi',
      cuppingDesc: 'Cả giác hơi khô và ướt để giảm căng cơ và cải thiện tuần hoàn.',
      herbal: 'Thuốc Thảo Dược',
      herbalDesc: 'Đơn thuốc thảo dược tùy chỉnh để hỗ trợ hành trình chữa lành của bạn.',
      stickers: 'Miếng Dán Châm Cứu',
      stickersDesc: 'Giải pháp chăm sóc tại nhà để tiếp tục chữa lành giữa các lần khám.'
    },
    // Testimonials
    testimonials: {
      caption: 'Câu Chuyện Bệnh Nhân',
      title: 'Bệnh Nhân Nói Gì',
      rating: 'Đánh Giá 5.0 Sao',
      reviews: '11 Đánh Giá',
      quote1: 'Cải thiện hơi thở và giấc ngủ. Sự kết hợp của phương pháp hiện đại và truyền thống.',
      quote2: 'Sau hai lần hẹn, Bác sĩ Choi đã thay đổi cuộc đời tôi! Giảm đau lưng dưới 8 năm của tôi.',
      quote3: 'Kết quả tuyệt vời cho các vấn đề xoang và mệt mỏi chung. Một báu vật ở Quận Cam.'
    },
    // Accessibility
    accessibility: {
      caption: 'Khả Năng Tiếp Cận',
      title: 'Chúng Tôi Chào Đón Tất Cả',
      statement: 'Phòng khám của chúng tôi hoàn toàn có thể tiếp cận và tuân thủ các tiêu chuẩn ADA. Chúng tôi cam kết cung cấp dịch vụ chăm sóc cho tất cả bệnh nhân.',
      wheelchair: 'Lối Vào Cho Xe Lăn',
      parking: 'Bãi Đỗ Xe Có Thể Tiếp Cận',
      restroom: 'Nhà Vệ Sinh Có Thể Tiếp Cận'
    },
    // Location
    location: {
      caption: 'Ghé Thăm Chúng Tôi',
      title: 'Tìm Phòng Khám',
      address: '9860 Garden Grove Blvd',
      city: 'Garden Grove, CA 92844',
      plaza: 'Hanmi Plaza',
      planning: 'Khuyến Nghị Đặt Lịch Hẹn',
      insurance: 'Bảo Hiểm Tuyệt Vời',
      payment: 'Chấp Nhận Thẻ Tín Dụng & Thẻ Ghi Nợ',
      hours: 'Giờ Làm Việc',
      monday: 'Thứ Hai',
      tuesday: 'Thứ Ba',
      wednesday: 'Thứ Tư',
      thursday: 'Thứ Năm',
      friday: 'Thứ Sáu',
      saturday: 'Thứ Bảy',
      sunday: 'Chủ Nhật',
      closed: 'Đóng cửa'
    },
    // Footer
    footer: {
      clinic: 'Healing Clinic',
      clinicKorean: '힐링한의원',
      tagline: 'Y Học Đông Phương Truyền Thống • Chữa Lành Hiện Đại',
      accessibilityStatement: 'Tuyên Bố Khả Năng Tiếp Cận',
      accessibilityText: 'Trang web này được thiết kế để tất cả người dùng có thể truy cập theo hướng dẫn WCAG 2.1 Level AA.',
      copyright: '© 2024 Healing Clinic. Bảo lưu mọi quyền.',
      seo: 'Châm Cứu Garden Grove | Châm Cứu Quận Cam'
    }
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'vi' : 'en');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
